import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./variable.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>

    <BrowserRouter>
      <App />
      
    </BrowserRouter>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

reportWebVitals();
